

$(function () {
  $('.js-dial-container').each((index, el) => {

    let parent = $(el);

    parent.find('.js-dial-item').on('mouseenter', function() {
      parent.attr('data-active', $(this).index());
    })
  });
});



// WEBPACK FOOTER //
// ./src/js/modules/dial.js